import {
    FETCH_PARTNER_PLANS_LOADING,
    FETCH_PARTNER_PLANS_SUCCESS,
    FETCH_PARTNER_PLANS_FAILED,
  } from "../types";

  const initialState = {
    data: [],
    loading: false,
    error: null,
  };

  export const partnerPlanReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case FETCH_PARTNER_PLANS_LOADING:
        return { ...state, loading: true, error: null };
      case FETCH_PARTNER_PLANS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case FETCH_PARTNER_PLANS_FAILED:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  